import { Injectable } from '@angular/core';
import { SemovelProvider } from '../semovel/semovel';

@Injectable()
export class ConversaProvider {

  constructor(private server: SemovelProvider) {
  }

  iniciarConversa(mensagem){
    return this.server.postData({method:"iniciar_conversa"}, {mensagem:mensagem});
  }

  encerrarConversa(conversaId){
    return this.server.postData({method:"encerrar_conversa"}, {conversa_id:conversaId});
  }
  
  enviarMensagem(conversaId, mensagem){
    return this.server.postData({method:"enviar_mensagem"}, {conversa_id:conversaId, mensagem:mensagem});
  }

  carregarMensagens(conversaId){
    return this.server.postData({method:"carregar_mensagens"}, {conversa_id:conversaId}, false);
  }

  carregar(){
    return this.server.postData({method:"carregar_conversas"});
  }
}



// WEBPACK FOOTER //
// ./src/providers/conversa/conversa.ts